import EndTrip from './EndTrip';
import StartTrip from './StartTrip';

class DispatchStartEndTrip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showStartTrip: false,
      enable: false
    };
  }

  componentDidMount() {
    this.props.eventHub.on(
      `${this.props.headerId}_updateEndTripIconStatus`,
      this.changeEndTripStatus
    );
  }

  componentWillUnmount() {
    this.props.eventHub.off(
      `${this.props.headerId}_updateEndTripIconStatus`,
      this.changeEndTripStatus
    );
  }

  changeEndTripStatus = (enable, showStartTrip) => {
    if (this.state.enable !== enable || this.state.showStartTrip !== showStartTrip) {
      this.setState({
        enable,
        showStartTrip
      });
    }
  };

  render() {
    const { showStartTrip, enable } = this.state;
    return showStartTrip ? (
      <StartTrip {...this.props} enable={enable} />
    ) : (
      <EndTrip {...this.props} enable={enable} />
    );
  }
}
export default DispatchStartEndTrip;
